import { Switch, Route, Redirect } from 'react-router-dom';

import HomePage from '@pages/Home';
import UserPage from '@pages/User';

import { UserProvider } from '@contexts/UserContext';

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={HomePage} />

      <Route exact path="/user/:username">
        <UserProvider>
          <UserPage />
        </UserProvider>
      </Route>

      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
